import { createContext } from 'react'

interface ContextInterface {
  setIsOpen: (isOpen: boolean) => void
}

export const PopOverContext = createContext<ContextInterface | undefined>(
  undefined
)
